window.$ = require("jquery");
window.jQuery = require("jquery");

require('datatables.net');

require("./app/blocks/main-nav");
require("./app/blocks/mail-list");

require("./app/blocks/overlay-terms-conditions");

require("./app/pages/race-subscribe-wizard");
require("./app/pages/circuit-subscribe-wizard");

require("./race-manager/race-order.js")

$(document).ready( () => {

	$(".print-icon").on("click tap", () => {
		window.print();
	});

	var team_members_table = $('#team-members').DataTable({
		paging: false,
		ordering: false,
		info: false,
		dom: 't'
	});

	/*
	* Search
	*/
	$('#search_team_member').keyup(function() {
		team_members_table.search($(this).val()).draw();
	});

	/*
	 * Get team members data buttons
	 */
	document.querySelectorAll('.team-members tbody tr').forEach( ($row) => {
		$row.addEventListener( 'click', (e) => {
				e.preventDefault()
				document.location = '?autofill-sub-id=' + $row.dataset.last_sub_id
			})
	})

});
